<template>
  <div class="myself_wrapper">
      <div>
        <el-tabs type="border-card" v-model="this.$route.path"  @tab-click="ToPage">
          <el-tab-pane 
          v-for="item in tabs"
          :key="item.name"
          :label="item.label"
          :name="item.name"
          >
          <router-view></router-view>
          </el-tab-pane>
        </el-tabs>	
      
      </div>

   
  </div>
</template>

<script>
import MyselfOrder from './components/myselfproduct'
import OrderList   from './components/orders'
export default {
  data() {
    return {
      tabs: [
        { label: this.$t('other.a3224'),   name: "/myselfproduct/goods",},
        { label: this.$t('other.a3225'), name: "/myselfproduct/order",},
        { label: this.$t('other.a3245'), name: "/myselfproduct/SampleApplication",},
        { label: this.$t('other.a3314'), name: "/myselfproduct/statistics",},
       
      ],
     
    }
  },
  computed: {


  },


  watch: {

  },
  components: {
  OrderList,
  MyselfOrder
  },
  created() {

    
  
 
    
  },
  methods: {
    ToPage(tab, event,name) {
			this.$router.push({path:tab.name})
		}
  },
};
</script>
<style lang="scss" scoped>
.myself_wrapper{
  margin-right: 5px;
}

.el-tabs__content{
  min-height: 100vh;
}



</style>